module.exports = __webpack_public_path__ + "img/AT0000002420550.6614da48.png";